
































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import DocumentsData from '@/ts/DocumentsData';
import DocumentReader from '@/components/Media/DocumentReader.vue';

@Component({
    components: {
        DocumentReader,
    },
})
export default class DocumentSign extends Mixins(DeviceMethods) {
    public selected: boolean = false;

    constructor() {
        super();
    }

    public selectChekbox() {
        this.selected = !this.selected;
    }

    get activeButtonClass(): object {
        return {
            'hococo-inactive': (!this.selected),
        };
    }

    get item(): DocumentsData {
        return this.$store.getters['Documents/getActiveDocument'];
    }

    get previewData() {
        if (!this.dataLoaded) {
            return null;
        }

        return this.$store.getters['Images/getDocumentPreview'](this.item.id);
    }

    get dataLoaded() {
        return (this.item && this.item !== null);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_DOCUMENT_PREVIEW, this.item.id);
    }

    public goBack() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Documents,
            viewMode: ViewModes.Documents.All,
        });
        this.$router.back();
    }

    public signContract() {
        if (this.selected) {
            this.$store.dispatch(Actions.SIGN_CONTRACT, this.item.id).then(() => {
                this.$router.push({
                    name: 'documentSigned',
                    params: {
                        documentId: this.item.id.toString(),
                    },
                });
            });
        }
    }

    public downloadPdf() {
        return false;

        // axios.get(Endpoints.DOCUMENT_DOWNLOAD_PDF(this.item.id), { responseType: 'blob' })
        //     .then((response) => {
        //         this.device().then((deviceInfo) => {
        //             if (deviceInfo.platform === 'web') {
        //                 const blob = new Blob([response.data], {
        //                     type: 'application/pdf;charset=utf-8',
        //                 });

        //                 saveAs(blob, this.item.title + '.pdf');
        //             } else {
        //                 const { Filesystem } = Plugins;

        //                 const fileReader = new FileReader();

        //                 fileReader.addEventListener('loadend', (event: any) => {
        //                     try {
        //                         Filesystem.writeFile({
        //                             path: 'hococo/' + this.item.title + '.pdf',
        //                             data: event.srcElement.result,
        //                             directory: FilesystemDirectory.Documents,
        //                             encoding: FilesystemEncoding.UTF8
        //                         }).then((result) => {
        //                             console.log("wrote file", result);

        //                             const { LocalNotifications } = Plugins;

        //                             LocalNotifications.schedule({
        //                                 notifications: [{
        //                                         title: 'Document Downloaded',
        //                                         body: "Document " + this.item.title + '.pdf saved to Documents.',
        //                                         id: 1,
        //                                         schedule: { at: new Date(Date.now() + 1000) },
        //                                         sound: null,
        //                                         attachments: null,
        //                                         actionTypeId: "",
        //                                         extra: null
        //                                 }]
        //                             });
        //                         });
        //                     } catch (e) {
        //                         console.error('Unable to write file', e);
        //                     }
        //                 });

        //                 fileReader.readAsBinaryString(response.data);
        //             }
        //         });

        // });
    }

    public showTerms() {
        this.$store.commit(Mutations.SHOW_TERMS);
    }
}
